var gMsg = {
    iosStartText: '进入游戏',
    startText: '启动游戏',
    iosStartText: '进入游戏',
    installText: '安装游戏',
    downloadText: '下载游戏',
    downloadingText: '下载中',
    gotGiftOK: '恭喜，礼包领取成功',
    exceedMsg: '你已达到领取上限，无法领取',
    cashExceedMsg: '活动太火爆，现金被领完了',
    cashTimeLimit: '红包服务器太忙，请稍后重试',
    cashAccountLimt: '很抱歉，本活动仅限微信活跃老用户参与',
    giftNotExists: '礼包已下架，暂时无法领取',
    giftTimeout: '礼包状态已过期，需刷新状态',
    roleNotExists: '未注册游戏角色，注册角色后再来领取',
    queryRoleError: '查询绑定角色失败',
    cantgetError: '你不满足领取条件，请完成任务后再来领取',
    gotGiftText: '你已经领取过奖励啦，赶紧去游戏查看吧',
    actOverText: '活动已经结束啦，小伙伴们期待下次的活动吧',
    errorText: '请刷新页面,稍后重试',
    dateError: '对不起，请于指定日期领取奖励！',
    downloading: '游戏下载中，请安装游戏后重试',
    failError: '对不起！领取失败，重新来一次！',
    notDown: '你还没有安装游戏，点击确定后下载游戏登录后才可以领取哦！',
    androidnotreadyText: '游戏Android版还未上架，感谢你的关注',
    iosnotreadyText: '游戏iOS版还未上架，感谢你的关注',
    notInstall: '你需要先下载并安装游戏，才可领取哟！',
    notFinish: '抱歉，你尚未完成任务，请完成后再来领取！',
    failType1: '你尚未登录，马上登录即可领取哦！',
    failType2: '你尚未达到指定分数，赶快进游戏刷新纪录吧！',
    failType4: '你尚未注册，马上注册即可领取哦！',
    failType5: '你尚未达到指定等级，赶快进游戏去攒经验吧！',
    failType6: '你尚未完成指定局数，赶快进游戏玩几把吧！',
    getItNow: '立即领取',
    gotIt: '已领取',
    invalidLogin: '无效的用户，请重新进入',
    whitelistErrMsg: '很抱歉，你不是本期的幸运星',
    actSigned: '你今日已经签到过啦，明天继续吧！'
};

export default {
    gMsg:gMsg
};